import AWS, { Config } from 'aws-sdk';
import {
  CognitoUserPool
} from 'amazon-cognito-identity-js';

function change(username, oldPassword, newPassword, config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  Config.region = config.region;
  const cognitoUser = userPool.getCurrentUser();
  const prom = new Promise((resolve, reject) => {
    cognitoUser.getSession((err, session) => {
      if (err) {
        console.log('error getting settion....');
        reject(err);
      } else if (!session.isValid()) {
        reject(new Error('Session is not valid'));
      } else {
        // console.log(session.accessToken.jwtToken);
        cognitoUser.changePassword(oldPassword, newPassword, (error, result) => {
          if (error) {
            reject(error);
          } else {
            resolve(result);
          }
        });
      }
    });
  });
  return prom;
}

export default function changePassword(username, oldPassword, newPassword, config) {
  console.log(`change password action: ${username}`);
  return dispatch => dispatch({
    type: 'CHANGE_PASSWORD_FETCH',
    payload: change(username, oldPassword, newPassword, config)
  });
}



// WEBPACK FOOTER //
// ./src/actions/changePassword.js